import React, { useState,useEffect } from 'react';
import AppRoutes from './Routes/AppRoutes';
import StartUpLoader from './UI/StartUpLoader/StartUpLoader';


function App() {
  return (
      <AppRoutes />
  );
}

export default App;

